import { render, staticRenderFns } from "./AsignaturaWrapper.vue?vue&type=template&id=4909c21b"
import script from "./AsignaturaWrapper.vue?vue&type=script&lang=js"
export * from "./AsignaturaWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports